import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * HTTP Interceptor that adds X-App-Id header to all requests to the backend API
 */
export const appIdInterceptor: HttpInterceptorFn = (req, next) => {
  // Get the base API URL from environment
  const baseApiUrl = typeof environment.baseApiUrl === 'string' 
    ? environment.baseApiUrl 
    : String(environment.baseApiUrl || '');

  // Check if the request is going to the backend API
  const requestUrl = req.url;
  const isBackendRequest = baseApiUrl && requestUrl.startsWith(baseApiUrl);

  // Add X-App-Id header if it's a backend request
  if (isBackendRequest) {
    const modifiedReq = req.clone({
      setHeaders: {
        'X-App-Id': 'web-app'
      }
    });
    return next(modifiedReq);
  }

  // For non-backend requests, pass through unchanged
  return next(req);
};
